export function getAutomationKey(
  value: unknown,
  fallback: string | number
): string {
  const raw =
    typeof value === 'string' || typeof value === 'number'
      ? String(value)
      : '';

  const normalizedValue = raw
    .trim()
    .toLowerCase()
    .replaceAll(/[^a-z0-9]+/g, '-')
    .replaceAll(/^-+/g, '')
    .replaceAll(/-+$/g, '');

  return normalizedValue || `${fallback}`;
}